var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideocall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.683,
    height: 10.844,
    viewBox: "0 0 15.683 10.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ag{opacity:0.57;}.ba{fill:#8c99a5;stroke:#8c99a5;stroke-width:0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ag",
    transform: "translate(0.1 -79.9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M15,80.968H13.547a.484.484,0,0,0-.344.14l-.823.827h-.769v-.484A1.451,1.451,0,0,0,10.16,80H1.451A1.451,1.451,0,0,0,0,81.451v7.741a1.451,1.451,0,0,0,1.451,1.451H10.16a1.451,1.451,0,0,0,1.451-1.451v-.484h.769l.827.827a.484.484,0,0,0,.339.14H15a.484.484,0,0,0,.484-.484V81.451A.484.484,0,0,0,15,80.968Zm-.484,7.741h-.769l-.827-.827a.484.484,0,0,0-.339-.14H11.128a.484.484,0,0,0-.484.484v.968a.484.484,0,0,1-.484.484H1.451a.484.484,0,0,1-.484-.484V81.451a.484.484,0,0,1,.484-.484H10.16a.484.484,0,0,1,.484.484V86.29h.968V82.9h.968a.484.484,0,0,0,.344-.14l.823-.827h.769Z",
    transform: "translate(0 -80)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocall);
export default __webpack_public_path__ + "static/media/videocall.5bdfd623.svg";
export { ForwardRef as ReactComponent };